/**
 * Real client-side collection filtering against data-* attributes rendered
 * on each .grid__item (see main-collection-product-grid.liquid). Replaces
 * the previous filter bar, whose controls were verified (live, via the
 * collection AJAX endpoint) to change nothing -- the width/length/person
 * slider's server-side condition was computed and never applied, and the
 * "Bettnutzung" toggle referenced a metafield key that doesn't exist on
 * the store.
 */
(function () {
  function initFilterDrawer(drawer) {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.grid__item'));
    if (!cards.length) return;

    var countEl = document.getElementById(drawer.id.replace('FilterDrawer', 'FilterCount'));
    var emptyEl = document.getElementById(drawer.id.replace('FilterDrawer', 'FilterEmpty'));
    var resetBtn = document.getElementById(drawer.id.replace('FilterDrawer', 'FilterReset'));

    var state = { persons: '', width: '', sleep: false, storage: false, covers: false, parttype: '' };

    function parseRange(v) {
      if (!v) return null;
      var parts = v.split('-');
      return [parseFloat(parts[0]), parseFloat(parts[1])];
    }

    function matches(card) {
      var persons = parseFloat(card.getAttribute('data-persons')) || 0;
      var width = parseFloat(card.getAttribute('data-width')) || 0;
      var sleep = card.getAttribute('data-sleep') === 'true';
      var storage = card.getAttribute('data-storage') === 'true';
      var covers = card.getAttribute('data-covers') === 'true';
      var parttype = card.getAttribute('data-parttype') || '';

      var pr = parseRange(state.persons);
      if (pr && (persons < pr[0] || persons > pr[1])) return false;

      var wr = parseRange(state.width);
      if (wr && (width < wr[0] || width > wr[1])) return false;

      if (state.sleep && !sleep) return false;
      if (state.storage && !storage) return false;
      if (state.covers && !covers) return false;
      if (state.parttype && parttype !== state.parttype) return false;

      return true;
    }

    function apply() {
      var visible = 0;
      cards.forEach(function (card) {
        var ok = matches(card);
        if (ok) {
          card.removeAttribute('data-filtered-out');
          visible++;
        } else {
          card.setAttribute('data-filtered-out', '');
        }
      });

      var activeCount = Object.keys(state).filter(function (k) {
        return state[k] !== '' && state[k] !== false;
      }).length;
      if (countEl) {
        if (activeCount > 0) {
          countEl.textContent = activeCount;
          countEl.hidden = false;
        } else {
          countEl.hidden = true;
        }
      }
      if (emptyEl) emptyEl.hidden = visible !== 0;
      grid.hidden = visible === 0;
    }

    drawer.querySelectorAll('[data-filter-group]').forEach(function (group) {
      var key = group.getAttribute('data-filter-group');
      group.querySelectorAll('.filter-chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
          group.querySelectorAll('.filter-chip').forEach(function (c) {
            c.classList.remove('is-active');
          });
          chip.classList.add('is-active');
          state[key] = chip.getAttribute('data-value') || '';
          apply();
        });
      });
    });

    drawer.querySelectorAll('[data-filter-toggle]').forEach(function (input) {
      var key = input.getAttribute('data-filter-toggle');
      input.addEventListener('change', function () {
        state[key] = input.checked;
        apply();
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        state = { persons: '', width: '', sleep: false, storage: false, covers: false, parttype: '' };
        drawer.querySelectorAll('.filter-chip').forEach(function (c, i) {
          c.classList.toggle('is-active', c.getAttribute('data-value') === '');
        });
        drawer.querySelectorAll('[data-filter-toggle]').forEach(function (i) {
          i.checked = false;
        });
        apply();
      });
    }
  }

  document.querySelectorAll('.filter-drawer').forEach(initFilterDrawer);
})();
